import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a97cdff6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=a97cdff6&prod&lang=stylus"
import style1 from "./index.vue?vue&type=style&index=1&id=a97cdff6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97cdff6",
  null
  
)

export default component.exports